import React, { lazy } from "react";
import './App.css';
import { PostcodeFinder } from '@bcc/react-postcode-finder';
import restrictions_data from './restrictedwards.json';
import Swal from 'sweetalert2';

const loadedData = JSON.stringify(restrictions_data);
const restrictions = JSON.parse(loadedData);


function testme(address){
      console.log(address);
      console.log(address.location.x+' '+address.location.y);
      getFeatureInfo(address.location);
}


function getFeatureInfo(incidentPoint){
  let url = 'https://maps.birmingham.gov.uk/server/rest/services/Internet_Boundaries/MapServer/0/query?f=json&geometryType=esriGeometryPoint&inSR=27700&outFields=WARDNME&outSR=27700&distance=10&units=esriSRUnit_Meter&returnGeometry=false&geometry=';

  let wardURL = url+incidentPoint.x+","+incidentPoint.y;
  
  fetch(wardURL)
  .then(response => response.json())
  .then(data => extractInfo(data));

}

function extractInfo(data){
console.log(data)
let ward = 'Unknown';
if (data.features.length>0){
  
  let feature = data.features[0].attributes;
  ward =  feature["WARDNME"];
}
console.log(ward)
if (ward !== 'Unknown'){
  let restricted = isContains(restrictions, ward);
  if (restricted) {
    showMessageDialog("success","You need to register for selective licensing as the address entered is in ",ward,true);
   }else{
    showMessageDialog("success","You do not need to register for selective licensing as the address entered is in ",ward,false);
   }
}else{
  showMessageDialog("warning","Ward not found for address entered","",false);
}
}

function showMessageDialog(icon, message, ward,showicon){
if (showicon === true) {
  Swal.fire({
    title: 'Birmingham City Council : Selective Licence - Address Check',
    icon: icon,
    html: message +'</b><p>'+ward+'</p>'
  });
}else{
  Swal.fire({
    title: 'Birmingham City Council : Selective Licence - Address Check',
    html: message +'</b><p>'+ward+'</p>'
  });
}

}

function isContains(json, value) {
  let contains = false;
  Object.keys(json).some(key => {
      contains = typeof json[key] === 'object' ? 
      isContains(json[key], value) : json[key] === value;
      return contains;
  });
  return contains;
}

function App() {
  return (
    <div className="App">
       <PostcodeFinder onSelectAddress={testme} service="OS" />
    </div>
  );
}

export default App;
